import api from "../../Environment";

/**
 * A-006.2 — Public Shop API helpers (userApi/shop/*).
 */

export async function fetchShopProducts(params = {}) {
  const response = await api.postMethod("shop/products", params);
  const body = response && response.data;
  if (!body || body.success === false) {
    return { products: [], pagination: null };
  }
  const data = body.data || {};
  return {
    products: Array.isArray(data.products) ? data.products : [],
    pagination: data.pagination || null,
  };
}

export async function fetchShopProduct({ slug, id } = {}) {
  const payload = {};
  if (slug) payload.slug = slug;
  if (id) payload.id = id;
  const response = await api.postMethod("shop/product", payload);
  const body = response && response.data;
  if (!body || body.success === false) {
    return null;
  }
  const data = body.data || {};
  return data.product || null;
}

export async function fetchShopCategories() {
  const response = await api.postMethod("shop/categories", {});
  const body = response && response.data;
  if (!body || body.success === false) {
    return [];
  }
  const data = body.data || {};
  return Array.isArray(data.categories) ? data.categories : [];
}

export function formatShopPrice(amount) {
  if (amount === null || amount === undefined || amount === "") {
    return null;
  }
  const n = Number(amount);
  if (!Number.isFinite(n)) {
    return null;
  }
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
    }).format(n);
  } catch (e) {
    return `$${n.toFixed(2)}`;
  }
}
